export default {
  'TOGGLE_CHEKCOUT01' (state, payload) {
    state.ShowCheckout = payload
  },
  'TOGGLE_SEARCH01' (state, payload) {
    state.ShowSearch01 = payload
  },
  'TOGGLE_SIDENAVE' (state, payload) {
    state.SideNave = payload
  },
  'PUSH_CHECKOUT01' (state, payload) {
    if(state.CheckoutItens01.filter(i => i.id === payload.item.id).length) {
      if(payload.qtda > 1) {
        state.CheckoutItens01.filter(i => i.id === payload.item.id)[0].qtda = state.CheckoutItens01.filter(i => i.id === payload.item.id)[0].qtda + payload.qtda
      }
      else {
        state.CheckoutItens01.filter(i => i.id === payload.item.id)[0].qtda = state.CheckoutItens01.filter(i => i.id === payload.item.id)[0].qtda + 1
      }
    }
    else {
      if(payload.qtda > 1) {
        payload.item.qtda = payload.qtda
        state.CheckoutItens01.push(payload.item)
      }
      else {
        payload.item.qtda = 1
        state.CheckoutItens01.push(payload.item)
      }
    }
  },
  'QTDA_CHECKOUTADD01' (state, payload) {
    state.CheckoutItens01.map(i => {
      if(payload.value > 0) {
        i.qtda = payload.value
        return
      }
      if(i.id === payload.id) {
        i.qtda++
      }
    })
  },
  'QTDA_CHECKOUTSUB01' (state, payload) {
    state.CheckoutItens01.map(i => {
      if(i.id === payload) {
        i.qtda--
      }
    })
  },
  'DELETE_CHECKOUT01' (state, payload) {
    let NewList = state.CheckoutItens01.filter(i => i.id !== payload.id)
    state.CheckoutItens01 = NewList
  },
  'ITEM_SELECTED01' (state, payload) {
    state.ItemSelected01 = payload
  },
  'SET_MODAL01' (state, payload) {
    state.Modal01 = payload
  },
  'SEARCH_PROD01' (state, payload) {
    if (payload === '') {
      state.ResultSearch01 = []
      return
    }
    state.ResultSearch01 = payload
  },
  'FILTER_CATEG' (state, payload) {
    state.CategSelected = payload
    let res = this.state.EnbPainel.Produtos.filter(p => p.categoria === payload)
    state.ResultFilterCateg = res
  },
  'PUSH_PROD' (_, payload) {
    this.state.EnbPainel.Produtos.unshift(payload)
  },
  'CLEAR_CHECKOUT01' (state) {
    state.CheckoutItens01 = []
  },
  'SELECT_PROPPROD' (state, payload) {
    let prop = state.ItemSelected01.atributos.filter(p => p.id === payload.prop.id)[0]
    prop.values.map(v => {
      if(v.id === payload.value.id) {
        v.selected = !v.selected
      }
      else {
        v.selected = false
      }
    })
    //prop.values.filter(v => v.id === payload.value.id)[0].selected = true
  },
  'CHANGE_FILTER_PROD_STORE' (state, payload) {
    for(let key in payload) {
      state.FilterProdStore[key] = payload[key]
    }
  },
  'SET_PRODUTOS_STORE' (state, payload) {
    if(payload.init) {
      state.ProdutosStore = payload.produtos
    } else {
      state.ProdutosStore = state.ProdutosStore.concat(payload.produtos)
    }
  }
}
